import { render, staticRenderFns } from "./searchItemComponent.vue?vue&type=template&id=a4bd8132&"
import script from "./searchItemComponent.vue?vue&type=script&lang=js&"
export * from "./searchItemComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports